module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-settings"
  }, [_c('div', {
    staticClass: "panelheader border-4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.pageName))])]), _vm._v(" "), _c('div', {
    staticClass: "settings"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.settings,
      "empty-text": "No Settings Found"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(_vm.newRow && (!props.row.name || !props.row.value)) ? _c('span', [_c('el-input', {
          attrs: {
            "placeholder": props.row.name
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              _vm.editSetting(props.row)
            },
            "keydown": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key)) { return null; }
              _vm.editSetting(props.row)
            }
          },
          model: {
            value: (props.row.name),
            callback: function($$v) {
              _vm.$set(props.row, "name", $$v)
            },
            expression: "props.row.name"
          }
        })], 1) : _c('span', [_vm._v("\n            " + _vm._s(props.row.name) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Value",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(_vm.editingRow == props.row.name) ? _c('span', [_c('el-input', {
          attrs: {
            "autofocus": "",
            "placeholder": props.row.value
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              _vm.editSetting(props.row)
            },
            "keydown": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key)) { return null; }
              _vm.editSetting(props.row)
            }
          },
          model: {
            value: (props.row.value),
            callback: function($$v) {
              _vm.$set(props.row, "value", $$v)
            },
            expression: "props.row.value"
          }
        })], 1) : _c('span', [_vm._v("\n            " + _vm._s(props.row.value) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), (_vm.userIsSuperAdmin) ? _c('el-table-column', {
    attrs: {
      "label": "Operations",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(!props.row.name) ? _c('span', [_c('el-tooltip', {
          staticClass: "op-tooltip",
          attrs: {
            "effect": "dark",
            "content": "New",
            "placement": "top",
            "enterable": false
          }
        }, [_c('button', {
          staticClass: "ui icon button more-btn",
          on: {
            "click": function($event) {
              _vm.enableNewRow(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "plus icon"
        })])])], 1) : (_vm.editingRow != props.row.name) ? _c('span', [_c('el-tooltip', {
          staticClass: "op-tooltip",
          attrs: {
            "effect": "dark",
            "content": "Edit",
            "placement": "top",
            "enterable": false
          }
        }, [_c('button', {
          staticClass: "ui icon button edit-btn",
          on: {
            "click": function($event) {
              _vm.editSetting(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "edit icon"
        })])])], 1) : _c('span', [_c('el-tooltip', {
          staticClass: "op-tooltip",
          attrs: {
            "effect": "dark",
            "content": "Confirm",
            "placement": "top",
            "enterable": false
          }
        }, [_c('button', {
          staticClass: "ui icon button confirm-btn",
          on: {
            "click": function($event) {
              _vm.editSetting(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "check icon"
        })])])], 1)]
      }
    }])
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-167425e5","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Settings.vue
// module id = 1175
// module chunks = 8